import ShareComponent from "./Share.vue";

export const shareRoutes = {
  path: "/share/:documentId",
  name: "share",
  component: ShareComponent,
  meta: {
    title: "Share",
    requireAuth: true,
  },
  props: true,
};
